export default "__VITE_ASSET__CtdaroLV__"